/**
 * 이용약관 (Terms of Service) - 한국어 v2
 * 
 * 시행일: 2026년 2월 1일
 */
export const TERMS_V2_KO = {
    version: "v2",
    effectiveDate: "2026-02-01",
    language: "ko",
    title: "이용약관",
    content: `
Spot Go 이용약관

최종 업데이트: 2026년 2월 1일 (KST)

본 이용약관("약관")은 개발자("당사", "우리")가 제공하는 Spot Go("서비스")의 이용에 관한 사항을 규정합니다. 서비스에 접속하거나 이용함으로써 귀하는 본 약관에 동의하게 됩니다.

1. 계정

귀하의 계정은 Pi Network 신원에 연결됩니다. 귀하는 본 약관 준수를 포함하여 귀하의 계정에서 발생하는 모든 활동에 대해 책임을 집니다.

1-1. 닉네임의 공개 표시 및 저장

귀하의 Pi Network 닉네임과 사용자 ID는 Pi Network 로그인 과정을 통해 수신되어 당사 서버에 안전하게 저장됩니다. 이러한 식별자는 귀하의 계정을 유지하고, 랭킹(예: 리더보드 및 이벤트)을 표시하며, 이용 내역을 확인하는 데 사용됩니다. 귀하의 닉네임은 서비스 내 다른 사용자에게 공개적으로 표시될 수 있습니다.

2. 가상 재화

서비스에는 가상 재화("가상 재화")가 포함될 수 있습니다. 이는 실제 화폐가 아닙니다.

• STAR: 광고 시청, 앱 이용, 이벤트 참여 등으로 획득하는 포인트
• TICKET: 앱 이용, 게시물 등록 등에 사용되는 아이템
• SPOT: LAND 방문, 콘텐츠 작성(포스트, 매장 등), 업적 달성 등에 따라 적립되는 서비스 내 포인트로서, 현재는 서비스 내 랭킹, 통계, 연출 등에만 사용되며 금전적 가치가 없습니다.

가상 재화(특히 SPOT 포함)는 어떠한 경우에도 현금 또는 기타 재화·용역으로 직접 교환, 환급, 송금, 양도, 담보 제공의 대상이 되지 않습니다.
관련 법률에서 요구하는 경우를 제외하고, 가상 재화의 모든 구매는 최종적이며 환불되지 않습니다. 당사는 통지 여부와 관계없이 언제든지 가상 재화를 관리, 규제, 통제, 수정 또는 제거할 권리를 가집니다.

3. 사용자 행동

귀하는 서비스를 오용하지 않기로 동의합니다. 여기에는 다음이 포함됩니다:
• 치팅, 버그 악용
• 자동화 소프트웨어(봇) 사용
• 소프트웨어 디컴파일
• 서비스 무결성 파괴 시도
• 허위 정보 등록
• 욕설, 비방, 음란물 등 부적절한 콘텐츠 게시
• 서비스의 목적(위치 기반 정보 공유)과 관련 없는 투기성, 시세 관련, 또는 허위·과장 정보 게시

4. 게시물 관리

이용자가 등록한 게시물(스팟)의 저작권은 해당 이용자에게 있습니다. 당사는 법령 위반, 타인 권리 침해, 허위 정보, 부적절한 콘텐츠 등에 해당하는 게시물을 사전 통지 없이 삭제할 수 있습니다.

5. 신고 및 제재

• 다른 이용자로부터 일정 횟수 이상 신고를 받은 게시물은 자동으로 숨김 처리될 수 있습니다.
• 반복적으로 신고를 받는 계정은 서비스 이용이 제한될 수 있습니다.
• 허위 또는 악의적인 신고를 반복하는 경우에도 계정이 제재될 수 있습니다.

6. 지적재산권

서비스(모든 콘텐츠, 기능, 기술 포함)는 개발자의 독점 재산입니다. 귀하에게는 개인적, 비상업적 용도로 서비스에 접속하고 이용할 수 있는 제한적이고 비독점적이며 양도 불가능한 라이선스가 부여됩니다.

7. 해지

귀하가 약관을 위반하는 경우 당사는 사전 통지나 책임 없이 즉시 서비스 접근을 해지하거나 정지할 수 있습니다. 접근 해지 시 서비스와 관련된 모든 데이터가 삭제될 수 있습니다.

8. 보증 부인 및 책임 제한

서비스는 "있는 그대로" 및 "이용 가능한 상태로" 제공됩니다. 법률이 허용하는 최대 범위 내에서 당사는 모든 종류의 보증을 부인합니다. 개발자는 귀하의 서비스 이용 또는 이용 불능으로 인한 간접적, 부수적, 특별, 결과적 또는 징벌적 손해에 대해 책임을 지지 않습니다.

9. 준거법 및 분쟁 해결

본 약관은 법률 충돌 조항에 관계없이 대한민국 법률에 의해 규율됩니다. 본 약관과 관련하여 발생하는 모든 분쟁은 수원지방법원의 전속 관할에 따릅니다.

10. 약관 변경

당사는 언제든지 본 약관을 수정할 권리를 보유합니다. 변경 사항은 서비스 내 또는 공식 웹사이트에 새로운 약관을 게시함으로써 통지됩니다.

11. 문의하기

질문이 있으시면 다음으로 연락해 주세요: lukep81@painori.com
`.trim()
};
